import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext, useFetch } from '@reveni-io/reveni-ui'

import configurationServices from '@/configuration/services/services'

import { attachBlockSettings, normalizeLayouts } from './helpers'
import { transformRequestEditOrderTrackingLayout } from './transformers'

const useSaveTrackingPageLayout = ({ storeId, layouts, blockSettings, saveBlockVisibility, onSaved }) => {
  const { t } = useTranslation()
  const { setToastInfo } = useContext(ToastContext)

  const { fetchData: editOrderTrackingLayout, loading: savingLayout } = useFetch(
    configurationServices.editOrderTrackingLayout,
    { doInitialRequest: false, transformRequest: transformRequestEditOrderTrackingLayout }
  )

  const handleSaveLayout = async () => {
    try {
      await editOrderTrackingLayout({ storeId, layouts: attachBlockSettings(normalizeLayouts(layouts), blockSettings) })
      await saveBlockVisibility()
      setToastInfo({ show: true, message: t('Cambios guardados'), type: 'success' })
      onSaved()
    } catch (error) {
      setToastInfo({ show: true, message: error.errorMessage, type: 'error' })
    }
  }

  return { handleSaveLayout, savingLayout }
}

export default useSaveTrackingPageLayout
